import React, { Component } from 'react';
import ImageBackground from '../common/imageBackground';
import ImageHeader from '../common/imageHeader';
import MyDashboard from './MyDashboard';
import Stay from './Stay';
import Education from './Education';
import Entertainment from './Entertainment';
import FallPrecaution from './FallPrecaution';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { withRouter } from 'react-router-dom';

let movement;
let sizeChange;
let highlightChange;
let newDashboard;
let services = ['mydashboard', 'stay', 'education', 'entertainment'];
class MainMenu extends Component {
  state = {
    mydashboard: 0,
    show: false,
    shrinkGrow: false,
    acceptKeys: true,
    hlState: 'out',
    currentPatient: this.props.currentPatient,
  };

  mmHeader = {
    id: 'mmHeader',
    src: require('./images/1101_' + this.props.currentPatient + '.png'),
    left: 5,
  };

  ARROW_LEFT = -1;
  ARROW_RIGHT = 1;

  handleOnKeyUp = (event) => {
    if (this.state.acceptKeys) {
      this.setState({
        hlState: 'out',
      });
      clearInterval(movement);
      clearInterval(sizeChange);
      clearInterval(highlightChange);
      newDashboard = this.state.mydashboard;

      if (!this.props.match.params.popup) {
        var myLeftRight = 'right';
        switch (event.key) {
          case 'ArrowRight':
            newDashboard--;

            if (newDashboard < -3) {
              newDashboard = -3;
            }
            break;
          case 'ArrowLeft':
            myLeftRight = 'left';
            newDashboard++;

            if (newDashboard > 0) {
              newDashboard = 0;
            }
            break;
          default:
        }

        if (this.state.mydashboard !== newDashboard) {
          this.setState({
            leftRight: myLeftRight,
            show: !this.state.show,
            acceptKeys: false,
            hlState: 'in',
          });

          movement = setInterval(this.movementDone.bind(this), 500);
          sizeChange = setInterval(this.makeThingsShrinkOrGrow.bind(this), 100);
        }
      }
    }
  };

  movementDone() {
    clearInterval(movement);
    clearInterval(highlightChange);

    this.setState({
      mydashboard: newDashboard,
      acceptKeys: true,
    });

    this.props.history.replace(
      '/main_menu/' + services[Math.abs(newDashboard)]
    );

    sizeChange = setInterval(this.makeThingsShrinkOrGrow.bind(this), 100);
    highlightChange = setInterval(this.changeHighlightOpacity.bind(this), 1000);
  }

  makeThingsShrinkOrGrow() {
    clearInterval(sizeChange);

    this.setState({
      shrinkGrow: !this.state.shrinkGrow,
    });
  }

  changeHighlightOpacity() {
    clearInterval(movement);
    clearInterval(sizeChange);
    clearInterval(highlightChange);
    this.setState({
      hlState: 'out',
    });
  }

  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);

    if (this.props.currentCategory !== '1') {
      newDashboard = parseInt(this.props.currentCategory, 10);
    }

    if (newDashboard === undefined) {
      newDashboard = 0;
    }

    this.setState({
      mydashboard: newDashboard,
      acceptKeys: true,
    });

    this.props.history.replace(
      '/main_menu/' + services[Math.abs(newDashboard)]
    );
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPatient !== this.props.currentPatient) {
      this.setState({
        currentPatient: this.props.currentPatient,
      });
      this.mmHeader = {
        id: 'mmHeader',
        src: require('./images/1101_' + this.props.currentPatient + '.png'),
        left: 5,
      };
    } else {
      return null;
    }
  }

  render() {
    const isFallPrecautionVisible =
      this.props.match.params.popup === 'fallPrecaution';
    return (
      <div className="main-menu">
        <ImageBackground id="background" isMainMenu={true} />
        <ImageHeader {...this.mmHeader} />
        <div className={`mm-links mm-links${newDashboard}`}>
          <MyDashboard
            hlState={this.state.hlState}
            shrinkGrow={this.state.shrinkGrow}
            movedir={this.state.leftRight}
            current={this.state.mydashboard}
            movingPos={newDashboard}
            disabled={isFallPrecautionVisible}
          />
          <Stay
            hlState={this.state.hlState}
            shrinkGrow={this.state.shrinkGrow}
            movedir={this.state.leftRight}
            current={this.state.mydashboard}
            movingPos={newDashboard}
            disabled={isFallPrecautionVisible}
          />
          <Education
            hlState={this.state.hlState}
            shrinkGrow={this.state.shrinkGrow}
            movedir={this.state.leftRight}
            current={this.state.mydashboard}
            movingPos={newDashboard}
            disabled={isFallPrecautionVisible}
          />
          <Entertainment
            hlState={this.state.hlState}
            shrinkGrow={this.state.shrinkGrow}
            movedir={this.state.leftRight}
            current={this.state.mydashboard}
            movingPos={newDashboard}
            disabled={isFallPrecautionVisible}
          />
          {isFallPrecautionVisible && <FallPrecaution />}
        </div>
      </div>
    );
  }
}

const ConnectedMainMenu = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(MainMenu);

export default withRouter(ConnectedMainMenu);
